import { useState, useEffect } from "react";
import { makeRequest } from "../../../utils/axios.js"; 

export const useSharePost = (handleShare, setOpenModal) => {
    const [desc, setDesc] = useState("");
    const [files, setFiles] = useState([]);
    const [postType, setPostType] = useState("Discussion");

    const [linkPreview, setLinkPreview] = useState(null); 
    const [isFetchingLink, setIsFetchingLink] = useState(false);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [cooldown, setCooldown] = useState(0);

    useEffect(() => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const match = desc.match(urlRegex);

        if (match && match.length > 0) {
            const url = match[0];
            if (!linkPreview || linkPreview.url !== url) {
                const fetchPreview = async () => {
                    setIsFetchingLink(true);
                    try {
                        const res = await makeRequest.post("/posts/preview", { url });
                        if (res.data) setLinkPreview(res.data);
                    } catch (err) {
                        console.error("Error retrieving preview link", err);
                        setLinkPreview(null); 
                    } finally {
                        setIsFetchingLink(false);
                    }
                };
                
                const delayDebounceFn = setTimeout(() => fetchPreview(), 1000);
                return () => clearTimeout(delayDebounceFn);
            }
        } else {
            setLinkPreview(null);
        }
    }, [desc, linkPreview]);

    useEffect(() => {
        let timer;
        if (cooldown > 0) {
            timer = setInterval(() => setCooldown((prev) => prev - 1), 1000);
        } else if (cooldown === 0 && errorMsg.includes("nhanh")) {
            setErrorMsg("");
        }
        return () => clearInterval(timer);
    }, [cooldown, errorMsg]);

    // const handleFileChange = (e) => {
    //     if (e.target.files && e.target.files.length > 0) {
    //         const newFiles = Array.from(e.target.files);
    //         setFiles((prev) => [...(prev || []), ...newFiles]);
    //     }
    //     e.target.value = null;
    // };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const newFiles = Array.from(e.target.files);
            
            const isValid = newFiles.every(file => file.size <= 20 * 1024 * 1024);
            if (!isValid) {
                setErrorMsg("File size must be less than 20MB");
                return;
            }

            setFiles((prev) => [...(prev || []), ...newFiles]);
        }
        e.target.value = null; 
    };

    // const removeFile = (indexToRemove) => {
    //     setFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
    // };

    const removeFile = (indexToRemove) => {
        setFiles((prev) => {
            const fileToRemove = prev[indexToRemove];
            if (fileToRemove) {
                URL.revokeObjectURL(URL.createObjectURL(fileToRemove)); 
            }
            return prev.filter((_, index) => index !== indexToRemove);
        });
    };

    const onShareClick = async (e) => {
        e.preventDefault();
        if (isSubmitting || cooldown > 0) return;

        setIsSubmitting(true);
        setErrorMsg("");

        try {
            await handleShare(desc, files, postType, linkPreview);
            setDesc("");
            setFiles([]);
            setOpenModal(false); 
        } catch (error) {
            if (error.response?.status === 429) {
                setErrorMsg("You posted too quickly. Please wait a moment!");
                setCooldown(60); 
            } else {
                setErrorMsg("An error occurred. Please try again later.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        desc, setDesc,
        files, handleFileChange, removeFile,
        postType, setPostType,
        linkPreview, isFetchingLink,
        isSubmitting, errorMsg, cooldown,
        onShareClick
    };
};